import Vue from 'vue';
import Vuex from 'vuex'
import Flags from "./modules/Flags";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        Flags
    }
});
